// extracted by mini-css-extract-plugin
module.exports = {"container":"transactions_container__3pHv9","transactions-list":"transactions_transactions-list__2f3rP","no-transactions":"transactions_no-transactions__1LU16"};